import Deals from './deals.png';
import Fanshop from './fanshop.png';
import DoodleJump from './doodle-jump.png';
import JumpAndRun from './jump-and-run.png';
import TapAndSmash from './tap-and-smash.png';

export const Hotspots = [Deals, Fanshop, DoodleJump, JumpAndRun, TapAndSmash];

export { default as FallbackEN } from './fallback-en.png';
export { default as FallbackHR } from './fallback-hr.png';
export { default as AboutEN } from './about-en.png';
export { default as AboutHR } from './about-hr.png';
export { default as MenuEN } from './menu-en.png';
export { default as MenuHR } from './menu-hr.png';
export { default as Button } from './button.png';
export { default as Logo } from './logo.png';
